import { ReactElement } from 'react';
import { CustomerSubscriptionStatuses } from '../../customersSubscription';
import { AlreadyActivated } from './alreadyActivated';
import { Created } from './created';
import { Unpaid } from './unpaid';
import { NotFound } from './notFound';
import { CustomerConflict } from './customerConflict';
import { Unknown } from './unknown';
import { Loading } from './loading';
import { ContentModel } from './content.model';
import { Activate } from './activate';

export const Content = ({ status }: ContentModel): ReactElement => {
  switch (status) {
    case CustomerSubscriptionStatuses.created: {
      return <Created />;
    }
    case CustomerSubscriptionStatuses.alreadyActivated: {
      return <AlreadyActivated />;
    }
    case CustomerSubscriptionStatuses.unpaid: {
      return <Unpaid />;
    }
    case CustomerSubscriptionStatuses.notFound: {
      return <NotFound />;
    }
    case CustomerSubscriptionStatuses.customerConflict: {
      return <CustomerConflict />;
    }
    case CustomerSubscriptionStatuses.unknown: {
      return <Unknown />;
    }
    case CustomerSubscriptionStatuses.loading: {
      return <Loading />;
    }
    case CustomerSubscriptionStatuses.activate: {
      return <Activate />;
    }
  }
};
